import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'lv',
  months: [
    'janvāris',
    'februāris',
    'marts',
    'aprīlis',
    'maijs',
    'jūnijs',
    'jūlijs',
    'augusts',
    'septembris',
    'oktobris',
    'novembris',
    'decembris',
  ],
  monthsShort: ['janv.', 'febr.', 'marts', 'apr.', 'maijs', 'jūn.', 'jūl.', 'aug.', 'sept.', 'okt.', 'nov.', 'dec.'],
  weekdays: ['svētdiena', 'pirmdiena', 'otrdiena', 'trešdiena', 'ceturtdiena', 'piektdiena', 'sestdiena'],
  weekdaysMin: ['Sv', 'P', 'O', 'T', 'C', 'Pk', 'S'],
  weekdaysShort: ['svētd.', 'pirmd.', 'otrd.', 'trešd.', 'ceturtd.', 'piektd.', 'sestd.'],
  formats: {
    LT: 'H.mm',
    LTS: 'H:mm:ss',
    lt: 'H.mm',
    lts: 'H:mm:ss',
    L: 'DD.MM.YYYY.',
    LL: 'YYYY. [gada] D. MMMM',
    'LL-D': 'YYYY. [gada] MMMM',
    'LL-Y': 'D. MMMM',
    LLL: 'YYYY. [gada] D. MMMM, HH.mm',
    'LLL-Y': 'D. MMMM, H.mm',
    LLLL: 'dddd, YYYY. [gada] D. MMMM, H.mm',
    'LLLL-Y': 'dddd, D. MMMM, H.mm',
    l: 'D.MM.YYYY.',
    'l-Y': 'D.MM.',
    ll: 'D. MMM YYYY',
    'll-Y': 'D. MMM',
    'll-D': 'MMM YYYY',
    lll: 'D. MMM YYYY, H.mm',
    'lll-Y': 'D. MMM H.mm',
    llll: 'ddd., YYYY. [gada] D. MMMM, HH.mm',
    'llll-Y': 'ddd, D. MMM H.mm',
    'll-Y+w': 'ddd, D. MMM',
    'LT+to': 'HH:mm [GMT]Z',
    'LLL+to': 'D. MMMM YYYY, H:mm [GMT]Z',
  },
  meridiem: { am: 'priekšp.', pm: 'pēcp.', AM: 'priekšp.', PM: 'pēcp.' },
  past: {
    y: { zero: 'pirms %s g.', one: 'pirms %s g.', other: 'pirms %s g.' },
    M: { zero: 'pirms %s mēn.', one: 'pirms %s mēn.', other: 'pirms %s mēn.' },
    w: { zero: 'pirms %s ned.', one: 'pirms %s ned.', other: 'pirms %s ned.' },
    d: { zero: 'pirms %s d.', one: 'pirms %s d.', other: 'pirms %s d.' },
    h: { zero: 'pirms %s h', one: 'pirms %s h', other: 'pirms %s h' },
    m: { zero: 'pirms %s min', one: 'pirms %s min', other: 'pirms %s min' },
    s: { zero: 'pirms %s s', one: 'pirms %s s', other: 'pirms %s s' },
  },
  future: {
    y: { zero: 'pēc %s g.', one: 'pēc %s g.', other: 'pēc %s g.' },
    M: { zero: 'pēc %s mēn.', one: 'pēc %s mēn.', other: 'pēc %s mēn.' },
    w: { zero: 'pēc %s ned.', one: 'pēc %s ned.', other: 'pēc %s ned.' },
    d: { zero: 'pēc %s d.', one: 'pēc %s d.', other: 'pēc %s d.' },
    h: { zero: 'pēc %s h', one: 'pēc %s h', other: 'pēc %s h' },
    m: { zero: 'pēc %s min', one: 'pēc %s min', other: 'pēc %s min' },
    s: { zero: 'pēc %s s', one: 'pēc %s s', other: 'pēc %s s' },
  },
  pastLong: {
    y: { zero: 'pirms %s gadiem', one: 'pirms %s gada', other: 'pirms %s gadiem' },
    M: { zero: 'pirms %s mēnešiem', one: 'pirms %s mēneša', other: 'pirms %s mēnešiem' },
    w: { zero: 'pirms %s nedēļām', one: 'pirms %s nedēļas', other: 'pirms %s nedēļām' },
    d: { zero: 'pirms %s dienām', one: 'pirms %s dienas', other: 'pirms %s dienām' },
    h: { zero: 'pirms %s stundām', one: 'pirms %s stundas', other: 'pirms %s stundām' },
    m: { zero: 'pirms %s minūtēm', one: 'pirms %s minūtes', other: 'pirms %s minūtēm' },
    s: { zero: 'pirms %s sekundēm', one: 'pirms %s sekundes', other: 'pirms %s sekundēm' },
  },
  futureLong: {
    y: { zero: 'pēc %s gadiem', one: 'pēc %s gada', other: 'pēc %s gadiem' },
    M: { zero: 'pēc %s mēnešiem', one: 'pēc %s mēneša', other: 'pēc %s mēnešiem' },
    w: { zero: 'pēc %s nedēļām', one: 'pēc %s nedēļas', other: 'pēc %s nedēļām' },
    d: { zero: 'pēc %s dienām', one: 'pēc %s dienas', other: 'pēc %s dienām' },
    h: { zero: 'pēc %s stundām', one: 'pēc %s stundas', other: 'pēc %s stundām' },
    m: { zero: 'pēc %s minūtēm', one: 'pēc %s minūtes', other: 'pēc %s minūtēm' },
    s: { zero: 'pēc %s sekundēm', one: 'pēc %s sekundes', other: 'pēc %s sekundēm' },
  },
  abbr: {
    y: { zero: '%s g.', one: '%s g.', other: '%s g.' },
    M: { zero: '%s mēn.', one: '%s mēn.', other: '%s mēn.' },
    w: { zero: '%s ned.', one: '%s ned.', other: '%s ned.' },
    d: { zero: '%s d.', one: '%s d.', other: '%s d.' },
    h: { zero: '%s h', one: '%s h', other: '%s h' },
    m: { zero: '%s min', one: '%s min', other: '%s min' },
    s: { zero: '%s s', one: '%s s', other: '%s s' },
  },
  full: {
    y: { zero: '%s gadu', one: '%s gads', other: '%s gadi' },
    M: { zero: '%s mēnešu', one: '%s mēnesis', other: '%s mēneši' },
    w: { zero: '%s nedēļu', one: '%s nedēļa', other: '%s nedēļas' },
    d: { zero: '%s dienu', one: '%s diena', other: '%s dienas' },
    h: { zero: '%s stundu', one: '%s stunda', other: '%s stundas' },
    m: { zero: '%s minūšu', one: '%s minūte', other: '%s minūtes' },
    s: { zero: '%s sekunžu', one: '%s sekunde', other: '%s sekundes' },
  },
  justNow: 'Tikko',
  yesterday: 'Vakar',
  today: 'Šodien',
  tomorrow: 'Rīt',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'YYYY. [gada] D. MMMM', end: 'YYYY. [gada] D. MMMM' },
    'yl-1': { start: 'D. MMMM', end: 'YYYY. [gada] D. MMMM' },
    ml: { start: 'D. MMMM', end: 'D. MMMM' },
    'ml-1': { start: 'YYYY. [gada] D.', end: 'D. MMMM' },
    dl: { start: 'D.', end: 'D. MMMM' },
    y: { start: 'YYYY. [gada] D. MMM', end: 'YYYY. [gada] D. MMM' },
    'y-1': { start: 'YYYY. [gada] D. MMM', end: 'D. MMM' },
    m: { start: 'D. MMM', end: 'D. MMM' },
    'm-1': { start: 'YYYY. [gada] D. MMM', end: 'D. MMM' },
    d: { start: 'D.', end: 'D. MMM' },
    Y: { start: 'ddd, YYYY. [gada] D. MMM', end: 'ddd, YYYY. [gada] D. MMM' },
    'Y-1': { start: 'ddd, D. MMM', end: 'ddd, D. MMM, YYYY' },
    M: { start: 'ddd, D. MMM', end: 'ddd, D. MMM' },
    D: { start: 'ddd, D. MMM', end: 'ddd, D. MMM' },
    yt: { start: 'YYYY. [gada] D. MMM HH:mm', end: 'YYYY. [gada] D. MMM HH:mm' },
    mt: { start: 'D. MMM HH:mm', end: 'D. MMM HH:mm' },
    dt: { start: 'D. MMM HH:mm', end: 'D. MMM HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'YYYY. [gada] D. MMM HH:mm', end: 'YYYY. [gada] D. MMM HH:mm [GMT]Z' },
    'mt+to': { start: 'D. MMM HH:mm', end: 'D. MMM HH:mm [GMT]Z' },
    'dt+to': { start: 'D. MMM HH:mm', end: 'D. MMM HH:mm [GMT]Z' },
    't+to': { start: 'HH:mm', end: 'HH:mm [GMT]Z' },
  },
};
const localeName: LocaleName = 'lv';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'priekšp.' : 'priekšp.';
    } else {
      return isLowerCase ? 'pēcp.' : 'pēcp.';
    }
  },
};
